export interface CreditPack {
  id: string;
  name: string;
  credits: number;
  price: number;
  savings: number;
  description: string;
  popular?: boolean;
}

export const CREDIT_PACKS: CreditPack[] = [
  {
    id: 'pack_50',
    name: '50 Credits',
    credits: 50,
    price: 112.50,
    savings: 10,
    description: 'Perfect for occasional events',
  },
  {
    id: 'pack_75',
    name: '75 Credits',
    credits: 75,
    price: 150,
    savings: 20,
    description: 'Best value for regular attendees',
    popular: true,
  },
  {
    id: 'pack_100',
    name: '100 Credits',
    credits: 100,
    price: 175,
    savings: 30,
    description: 'Maximum savings for enthusiasts',
  },
];
